import * as Actions from '../../actions/taxClass/type';

const initialState = {
  listLoading: false,
  listData: [],
  listError: null,
  addLoading: false,
  addSuccess: {},
  addError: null,
  update: {},
  updateLoading: false,
  updateError: null,
};

const taxClassReducer = (state = initialState, { type, payload }) => {
  // Get Tax Class Listing
  switch (type) {
    case Actions.GET_TAX_CLASS_LIST_REQUEST:
      return {
        ...state,
        listLoading: true,
      };
    case Actions.GET_TAX_CLASS_LIST_SUCCESS:
      return {
        ...state,
        listLoading: false,
        listData: payload?.data?.data || [],
      };
    case Actions.GET_TAX_CLASS_LIST_FAIL:
      return {
        ...state,
        listLoading: false,
        listError: payload,
      };

    // Add New Tax Class

    case Actions.ADD_TAX_CLASS_REQUEST:
      return {
        ...state,
        addLoading: true,
      };
    case Actions.ADD_TAX_CLASS_SUCCESS:
      return {
        ...state,
        addLoading: false,
        newClass: payload?.data?.data || {},
      };
    case Actions.ADD_TAX_CLASS_FAIL:
      return {
        ...state,
        addLoading: false,
        addError: payload,
      };
    case Actions.UPDATE_TAX_CLASS_STATE:
      return {
        ...state,
        listData: [...state?.listData, payload?.data?.data],
      };

    // Add New Tax Class

    case Actions.UPDATE_TAX_CLASS_REQUEST:
      return {
        ...state,
        updateLoading: true,
      };
    case Actions.UPDATE_TAX_CLASS_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        updatedClass: payload?.data?.data || {},
      };
    case Actions.UPDATE_TAX_CLASS_FAIL:
      return {
        ...state,
        updateLoading: false,
        updateError: payload,
      };

    case 'CLEAR_TAX_CLASS_STATE':
      return {
        ...state,
        addLoading: false,
        newClass: {},
        updatedClass: {},
      };

    default:
      return state;
  }
};

export default taxClassReducer;
